import { render } from "./AppPolicy.vue?vue&type=template&id=ec8b5c14"
import script from "./AppPolicy.vue?vue&type=script&lang=js"
export * from "./AppPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__